import React, { useContext } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { getGliddenBannerInfo, getBehrBannerInfo } from '../../utils/bannerUtils';
import { DESKTOP } from '../../constants/Constants';
import { LayoutContext } from '../../context/Contexts';

// Desktop/Tablet image intrinsic size: 700 x 100 px
// Mobile image intrinsic size: 375 x 85 px
export const PromoBanners = () => {
  const behrInfo = getBehrBannerInfo(useConfigService);
  const gliddenInfo = getGliddenBannerInfo(useConfigService);
  const { channel } = useContext(LayoutContext);

  return (
    <div className="sui-flex sui-items-center sui-justify-center sui-w-full sui-mx-3 sui-my-4 sui-flex-wrap md:sui-flex-nowrap">
      <a 
        href={behrInfo.redirectLink} 
        className="sui-block sui-h-auto sui-relative sui-overflow-hidden"
        style={{
          marginRight: channel?.toUpperCase() === DESKTOP ? '2rem' : '0',
          marginBottom: channel?.toUpperCase() === DESKTOP ? '0' : '2rem'
        }}
      >
        <img 
          src={behrInfo.image} 
          alt="promo1" 
          title="promo1" 
          className="sui-max-w-full sui-h-auto"
        />
      </a>
      <a 
        href={gliddenInfo.redirectLink} 
        className="sui-block sui-h-auto sui-relative sui-overflow-hidden"
      >
        <img 
          src={gliddenInfo.image} 
          alt="promo2" 
          title="promo2" 
          className="sui-max-w-full sui-h-auto"
        />
      </a>
    </div>
  );
};
